export const renameSignatureFile = (file: File, fileName: string, selectedFileExtension: string) => {
    const renamedFile = new File([file], `${fileName}${selectedFileExtension}`, {
        type: file.type,
        lastModified: file.lastModified,
    });

    return renamedFile;
};
